export class MemberApplicationStatusModel {
    MasterCustomerId: string;
    MemberGroup: string;
    ResidencyEndDate: Date;
    Status: string;
    ApplicationTypeId: string;
}
